export const trackCookieBanner = ({
  action,
}: {
  action: 'close' | 'accept' | 'link';
}) => {
  const event = {
    event: 'cookieBanner',
    action: action,
    label: null,
    value: null,
  };

  return event;
};
